module.exports = __webpack_public_path__ + "static/media/default-fallback.41aabc56.svg";